import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.scrollEventListener = this.onScroll.bind(this)
    window.addEventListener('scroll', this.scrollEventListener)
  }

  disconnect() {
    document.documentElement.classList.remove('is-open')
    window.removeEventListener('scroll', this.scrollEventListener)
    this.scrollEventListener = null
  }

  toggle() {
    document.documentElement.classList.toggle('is-open')
  }

  close() {
    document.documentElement.classList.remove('is-open')
  }

  onScroll() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop

    if (scrollPosition > 20) {
      document.documentElement.classList.add('is-scroll')
    } else {
      document.documentElement.classList.remove('is-scroll')
    }
  }
}
